// Numeric values must match the backend's ModuleEnum
// (Emeis.Shared.Relational/Authorization/JwtBearerEventsFactory.cs) exactly —
// these ids are what the backend actually checks permissions against.
export const AllModules = {
  Role: 1,
  Group: 2,
  Member: 3,
  BusinessUnit: 4,
  Notification: 5,
  Department: 6,
  Contract: 7,
  Obligation: 8,
  Receivable: 9,
  Template: 10,
  Party: 11,
  Dashboard: 12,
  Licensing: 13,
  ReceivableInvoice: 14,
  ReceivableTemplate: 15,
} as any;

// Numeric values must match the backend's Permission enum in the same file
// — every [PermissionAuthorize] on a controller checks one of these, so a
// missing or wrong value here means the UI shows a button the API rejects.
export const AllActions = {
  CREATE: 1,
  EDIT: 2,
  REMOVE: 3,
  SEARCH: 4,
  UPLOADMEDIA: 5,
  ACTIVATE: 6,
  DEACTIVATE: 7,
  REVERT: 8,
  PUBLISH: 9,
  CHANGESTATUS: 10,
  GENERATE_CERTIFICATE: 11,
  SEND_FOR_APPROVAL: 12,
  SEND_TO_REVIEWER: 13,
  SEND_FOR_EXTERNAL_REVIEW: 14,
  UNASSIGN: 16,
  APPROVE: 17,
  REJECT: 18,
  COMPLETE_REVIEW: 19,
  UPDATE_CAF: 20,
  SEND_TO_EDITOR: 21,
  SEND_TO_REPOSITORY: 22,
  SEND_FOR_SIGNATURE: 23,
  // Receivables Recovery
  PAUSE: 24,
  RESTART: 25,
  RECORD_PAYMENT: 26,
  DISPOSE: 27,
  WRITE_OFF: 28,
  CREATE_CASE: 29,
  VIEW_AUDIT: 30,
  CONFIGURE: 31,
} as any;

export type ModuleName = (typeof AllModules)[keyof typeof AllModules];
export type ActionName = (typeof AllActions)[keyof typeof AllActions];
